import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import styles from './ep-pricing-esm-components-from-price-from-price.module.scss.js';
import { clsx } from './ep-pricing-esm-external-clsx-dist-clsx.js';
import { FlexBox, ErrorBoundary, Typography } from '@vp/swan';
import { PriceInternal } from './ep-pricing-esm-components-price-price.component.js';
import { UnitPriceWithQuantityInternal } from './ep-pricing-esm-components-unit-price-with-quantity-unit-price-with-quantity.component.js';
import { VatMessageInternal } from './ep-pricing-esm-components-vat-message-vat-message.component.js';
import { useLocalization } from './ep-pricing-esm-hooks-useLocalizations.js';
import { UnitsCountInternal } from './ep-pricing-esm-components-units-count-units-count.component.js';
import { UnitPriceInternal } from './ep-pricing-esm-components-unit-price-unit-price.component.js';

const FromPriceInternal = forwardRef((props, ref) => {
  const { className, fromPriceConfig, placeholdertext, ...rest } = props;
  const classNames = clsx(className, styles.fromPrice);
  const { unitListPrice, unitDiscountedPrice, quantity, vatInc = false, shippingIncl, hideShippingMessageInVatMessage, locale } = fromPriceConfig;
  const { t } = useLocalization(locale);
  const renderVatMessage = () => {
    return /* @__PURE__ */ jsx(VatMessageInternal, { locale, vatAndShippingConfig: { vatInc, shippingIncl, hideShippingMessageInVatMessage }, placeholdertext, fontSkin: "footnote" });
  };
  const renderUnitPriceAndQuantity = () => {
    if (unitListPrice && unitDiscountedPrice && quantity) {
      return /* @__PURE__ */ jsx(
        UnitPriceWithQuantityInternal,
        {
          unitPriceConfig: { ...fromPriceConfig, unitListPrice, unitDiscountedPrice, quantity },
          placeholdertext,
          fontSkin: "footnote"
        }
      );
    }
    if (unitListPrice && unitDiscountedPrice) {
      return /* @__PURE__ */ jsx(UnitPriceInternal, { unitPriceConfig: { ...fromPriceConfig, unitListPrice, unitDiscountedPrice }, placeholdertext, fontSkin: "footnote" });
    }
    if (quantity) {
      return /* @__PURE__ */ jsx(UnitsCountInternal, { locale, quantity, placeholdertext, fontSkin: "footnote" });
    }
    return null;
  };
  const renderFromPrice = () => /* @__PURE__ */ jsx(Typography, { as: "span", fontSkin: "body-small", textColor: "standard", children: t("priceFrom", {
    price: /* @__PURE__ */ jsx(PriceInternal, { priceConfig: fromPriceConfig, placeholdertext, fontSkin: "body-small" })
  }) });
  return /* @__PURE__ */ jsxs(FlexBox, { flexDirection: "column", gap: 0, className: classNames, ...rest, ref, children: [
    renderFromPrice(),
    renderUnitPriceAndQuantity(),
    renderVatMessage()
  ] });
});
const FromPrice = forwardRef((props, ref) => /* @__PURE__ */ jsx(ErrorBoundary, { fallback: /* @__PURE__ */ jsx(FlexBox, { fontSize: "small", children: props.placeholdertext }), children: /* @__PURE__ */ jsx(FromPriceInternal, { ...props, ref }) }));

export { FromPrice };
//# sourceMappingURL=ep-pricing-esm-components-from-price-from-price.component.js.map
